import { LocationDetails } from '@/types/locationDetails';

const RECENT_LOCATIONS_KEY = 'paire_recent_locations';
const MAX_RECENT_LOCATIONS = 5;

/**
 * Load recent locations from localStorage
 */
export function loadRecentLocations(): Record<string, LocationDetails> {
  try {
    const stored = localStorage.getItem(RECENT_LOCATIONS_KEY);
    if (!stored) {
      return {};
    }
    return JSON.parse(stored) as Record<string, LocationDetails>;
  } catch (error) {
    console.error('Error loading recent locations:', error);
    return {};
  }
}

/**
 * Save recent locations to localStorage
 */
export function saveRecentLocations(locations: Record<string, LocationDetails>): void {
  try {
    localStorage.setItem(RECENT_LOCATIONS_KEY, JSON.stringify(locations));
  } catch (error) {
    console.error('Error saving recent locations:', error);
  }
}

/**
 * Add a location to recent locations and persist to storage
 * Returns the updated locations object
 */
export function addRecentLocation(location: LocationDetails): Record<string, LocationDetails> {
  try {
    const existing = loadRecentLocations();

    // Check if location already exists
    if (existing[location.placeId]) {
      return existing;
    }

    // If at max capacity, remove the oldest entry (first key)
    const keys = Object.keys(existing);
    if (keys.length >= MAX_RECENT_LOCATIONS) {
      delete existing[keys[0]];
    }

    // Add new location
    existing[location.placeId] = location;

    // Persist to storage
    saveRecentLocations(existing);

    return existing;
  } catch (error) {
    console.error('Error adding recent location:', error);
    return loadRecentLocations();
  }
}

/**
 * Clear all recent locations from storage
 */
export function clearRecentLocations(): void {
  try {
    localStorage.removeItem(RECENT_LOCATIONS_KEY);
  } catch (error) {
    console.error('Error clearing recent locations:', error);
  }
}
